/**
 * Represents the zeus.apollon_fk_conf.conf.projekt value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, Model, type MutationsObject } from '@kp/js-model';
import { ProjektFeldGruppe } from '@/models/apollon_conf_fk/ProjektFeldGruppe';

export class Projekt extends Model {
    public infotext: string | null = null;
    public feldgruppen: ProjektFeldGruppe[] = [];

    mutations(): MutationsObject {
        return {
            feldgruppen: (val: ProjektFeldGruppe[]) => (val ? val.map((gruppe) => createModel(ProjektFeldGruppe, gruppe)) : [])
        };
    }
}
